<template>
    <section>
        <div class="carousel carousel-dark slide" data-bs-ride="carousel" id="carouselDark">
            <div class="carousel-indicators">
                <button type="button" data-bs-target="#slider" data-bs-slide-to="0" class="active"></button>
                <button type="button" data-bs-target="#slider" data-bs-slide-to="1"></button>
                <button type="button" data-bs-target="#slider" data-bs-slide-to="2"></button>
            </div>
            <div class="carousel-inner">
                <div class="carousel-item active" data-bs-interval="10000">
                    <img src="/assets/images/slider/01.jpg" class="d-block w-100" alt="Slider Image">
                    <div class="carousel-caption d-none d-md-block">
                        <h5 class="text-white">Slider 01</h5>
                        <p class="text-white">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis, quam.</p>
                    </div>
                </div>
                <div class="carousel-item" data-bs-interval="2000">
                    <img src="/assets/images/slider/02.jpg" class="d-block w-100" alt="Slider Image">
                    <div class="carousel-caption d-none d-md-block">
                        <h5 class="text-white">Slider 02</h5>
                        <p class="text-white">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis, quam.</p>
                    </div>
                </div>
                <div class="carousel-item">
                    <img src="/assets/images/slider/03.jpg" class="d-block w-100" alt="Slider Image">
                    <div class="carousel-caption d-none d-md-block">
                        <h5 class="text-dark">Slider 03</h5>
                        <p class="text-dark">Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis, quam.</p>
                    </div>
                </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselDark" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselDark" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>
        </div>
    </section>
</template>
<script>
export default {
    name: 'SliderComponent',
}
</script>
<style>
</style>